import { useState } from 'react';

interface PdfViewerState {
  isOpen: boolean;
  pdfUrl: string | null;
  title: string | null;
}

export function usePdfViewer() {
  const [state, setState] = useState<PdfViewerState>({
    isOpen: false,
    pdfUrl: null,
    title: null,
  });

  const openPdf = (pdfUrl: string, title?: string) => {
    setState({
      isOpen: true,
      pdfUrl,
      title: title || 'PDF Document',
    });
  };

  const closePdf = () => {
    setState({
      isOpen: false,
      pdfUrl: null,
      title: null,
    });
  };

  return {
    ...state,
    openPdf,
    closePdf,
  };
}
